import React from 'react';
import { Skeleton, Stack } from '@mui/material';
import useIframeComponentHook from './useIframeComponentHook';
import './styles.scss';

const IframeComponent = ({ src }) => {
  const { skeletonLoader, iframeRef, iframeKey } = useIframeComponentHook({ src });

  return (
    <>
      {src && (
        <iframe
          key={iframeKey}
          id="iframe-component-configuracoes"
          className={`iframe-component-configuracoes ${skeletonLoader ? 'hidden' : ''}`}
          title="Responsive Iframe"
          allow="clipboard-read; clipboard-write"
          ref={iframeRef}
          src={src}
        />
      )}

      {skeletonLoader && (
        <Stack className="box-loading-iframe" spacing={1}>
          {[...Array(4)].map((_, index) => (
            <React.Fragment key={index}>
              <Skeleton variant="text" width={index === 0 ? '20%' : '100%'} height={50} />
              <Skeleton variant="rectangular" width={index === 0 ? '20%' : '100%'} height={50} />
            </React.Fragment>
          ))}
        </Stack>
      )}
    </>
  );
};

export default IframeComponent;
